import { View, Text, FlatList, TouchableOpacity, useWindowDimensions } from "react-native"
import { colorPalette, globalStyles } from "../../static/styles/global"
import { Ionicons } from '@expo/vector-icons'
import { CheckBox } from 'react-native-elements'
import { useState, useTransition } from "react"
import CustomButton from "../../components/shared/button/Button"
import { useFormsStore } from "../../stores/onboarding"
import { useInitializeStore } from "../../stores/initialize"
import { usePersonalStore } from "../../stores/personalInfo"
import { useHomeStore } from "../../stores/home"
import Toast from 'react-native-toast-message'
import { useTranslation } from "react-i18next"

const RequestForm = ({ data, setVisible }: any) => {

    const { height } = useWindowDimensions()

    const [selectedForms, setSelectedForms] = useState<any>([]);
    const { postRequestFormList, fetchData, loading } = useFormsStore((state) => ({
        postRequestFormList: state.postRequestFormList,
        fetchData: state.fetchData,
        loading: state.loading
    }))
    const intializeStore = useInitializeStore()
    const personalStore = usePersonalStore()
    const homeStore = useHomeStore()
    const { t } = useTranslation()


    const toggleForm = (formKey: number) => {
        setSelectedForms((prev: any) =>
            prev.includes(formKey)
                ? prev.filter((id: number) => id !== formKey)
                : [...prev, formKey]
        );
    };


    const handleSubmit = async () => {
        setVisible(false)
        try {
            const data = {
                essUserKey: intializeStore.initializeData?.userkey,
                entityId: personalStore.personalData?.entityId,
                storeId: homeStore?.homeData?.storeNumber,
                formKeys: selectedForms
            }
            const response = await postRequestFormList(data);
            if (response?.success) {
                await Toast.show({
                    type: 'success',
                    position: 'bottom',
                    text1: t(response?.message),
                    visibilityTime: 3000,
                    autoHide: true,
                    topOffset: 60,
                })
                const userId = intializeStore.initializeData?.mostRecentUserOnBoardings
                if (userId) {
                    await fetchData(userId)
                }
            }
            else {
                await Toast.show({
                    type: 'error',
                    position: 'bottom',
                    text1: t(response?.error),
                    visibilityTime: 3000,
                    autoHide: true,
                    topOffset: 60
                })
            }
        }
        catch (err) {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: err?.message || "something went wrong",
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }


    return (
        <View style={{ maxHeight: height * 0.7 }}>
            <View style={{ margin: 5, padding: 5 }}>
                <Text style={[globalStyles.title]}>{t("Choose the forms you would like to request from the admin")}</Text>
            </View>
            <TouchableOpacity
                style={{ flexDirection: "row", justifyContent: "flex-end", marginBottom: 5, marginRight: 10 }}
                onPress={() => setVisible(false)}
            >
                <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
            </TouchableOpacity>

            <FlatList
                data={data}
                renderItem={({ item }) => (
                    <View style={{
                        backgroundColor: colorPalette.light,
                        padding: 4,
                        borderRadius: 8,
                        marginVertical: 5,
                        marginHorizontal: 10,
                    }}>
                        <CheckBox
                            title={item.name}
                            checkedColor="#000"
                            uncheckedColor="#000"
                            containerStyle={{ backgroundColor: 'transparent', borderWidth: 0 }}
                            titleProps={{
                                style: {
                                    fontWeight: "normal",
                                    color: "#000"
                                }
                            }}
                            checked={selectedForms.includes(item.formKey)}
                            onPress={() => toggleForm(item.formKey)}
                        />
                    </View>
                )}
                keyExtractor={(item, index) => index.toString()}
            />

            <View style={{ flexDirection: "row", justifyContent: "flex-end", gap: 10, padding: 10, margin: 10 }}>
                <CustomButton text={t('Cancel')} onPress={() => { setVisible(false) }} color="danger" />
                <CustomButton text={t('Save')} onPress={() => { handleSubmit() }} isDisabled={selectedForms?.length === 0} color="success" />
            </View>
        </View>

    )
}

export default RequestForm
